import { css } from '@emotion/css'
import { spacing, colors } from '@offerzen/pinata-shame'

const styles = {
  list: css({
    listStyle: 'none',
    margin: 0,
    marginBottom: spacing.large,
    padding: 0,
  }),
  listItem: css({
    '&:not(:first-child)': {
      paddingTop: spacing.large,
    },

    ':not(:last-child)': {
      borderBottom: `1px dashed ${colors.mystic}`,
      paddingBottom: spacing.medium,
    },
  }),
}

export default styles
